import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import TenantActions from '@Actions/tenantActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import { v4 as uuidv4 } from 'uuid';
import ImgCrop from 'antd-img-crop';
import { Checkbox, Upload, Select, Table } from 'antd';
import constants, { Countries, CountryCodes } from '@Apis/constants';
import { PlusOutlined, PlusCircleFilled, CloseOutlined } from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import './style.scss';
import H3ImageSelectorWithCrop from '../../../uilib/H3ImageSelectorWithCrop';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const TenantForm = ({
  user, callback, updateTenant, updateTenantConfiguration, getTenantsConfiguration, tenantsConfiguration, createTenant, createTenantLoading, updateTenantLoading, selectedTenant, getCityState, setCityState, pincodeState, pincodeCity,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [tenantName, setTenantName] = useState('');
  const [legalName, setLegalName] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [phone, setPhone] = useState('');
  const [gstin, setGstin] = useState('');
  const [email, setEmail] = useState('');
  const [toRecipients, setToRecipients] = useState([]);
  const [address, setAddress] = useState('');
  const [pinCode, setPinCode] = useState('');
  const [district, setDistrict] = useState('');
  const [state, setState] = useState('');
  const [branchCode, setBranchCode] = useState('');
  const [fileList, setFileList] = useState([]);
  const [addExistingProducts, setAddExistingProducts] = useState(false);
  const [addExistingVendors, setAddExistingVendors] = useState(false);
  const [selectedTenantId, setSelectedTenantId] = useState('');
  const [tenantsConfig, setTenantsConfig] = useState('');
  const [ciData, setCIData] = useState([{
    identification_name: 'GSTIN',
    identification_number: '',
    is_printable: false,
  }]);

  useEffect(() => {
    if (pincodeCity) {
      const city = pincodeCity;
      const cityState = pincodeState;
      setCityState(null, null);
      setDistrict(city);
      setState(cityState);
    }
  }, [pincodeCity]);

  useEffect(() => {
    if (selectedTenant && tenantsConfiguration && !tenantsConfig) {
      const response = { thumbUrl: tenantsConfiguration?.data?.[0]?.logo_base_64 };
      setFileList(tenantsConfiguration?.data?.[0]?.logo_base_64 ? [response] : []);
      setTenantsConfig(tenantsConfiguration);
    }
  }, [tenantsConfiguration, tenantsConfig]);

  useEffect(() => {
    if (selectedTenant) {
      setTenantName(selectedTenant?.tenant_name);
      setLegalName(selectedTenant?.legal_name);
      setPhone(selectedTenant?.mobile);
      setEmail(selectedTenant?.email);
      setToRecipients(selectedTenant?.secondary_email);
      setGstin(selectedTenant?.gst_number);
      setBranchCode(selectedTenant?.branch_code);
      setSelectedTenantId(selectedTenant?.tenant_id);
      setCountryCode(String(selectedTenant?.dial_code) || Helpers.getDialCode(user?.tenant_info?.country_code));
      setCIData(selectedTenant?.identification_number?.map((item) => ({ ...item, key: uuidv4() })) || [{
        identification_name: 'GSTIN',
        identification_number: '',
        is_printable: false,
      },]);
    } else {
      setCountryCode(Helpers.getDialCode(user?.tenant_info?.country_code));
    }
  }, []);

  const uploadButton = (
    <div>
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    </div>
  );

  const handleDelete = (key) => {
    const copyCIData = ciData?.filter((item) => item?.key !== key);
    setCIData(copyCIData)
  };

  const getColumns = () => {
    const columns = [
      {
        title: 'Identification Name',
        render: (record) => {
          return (
            <H3FormInput
              value={record?.identification_name}
              type="text"
              // containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName={(formSubmitted && (!record?.identification_name)) ? 'orgFormInputError' : 'orgFormInput border-less'}
              onChange={(event) => {
                const copyData = JSON.parse(JSON.stringify(ciData));
                for (let i = 0; i < copyData?.length; i++) {
                  if (copyData[i]?.key === record?.key) {
                    copyData[i].identification_name = event.target.value;
                  }
                }
                setCIData(copyData);
              }}
              disabled={createTenantLoading || updateTenantLoading}
            />
          )
        }
      },
      {
        title: 'Identification Number',
        render: (record) => {
          return (
            <H3FormInput
              value={record?.identification_number}
              type="text"
              // containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName={(formSubmitted && (!record?.identification_number)) ? 'orgFormInputError' : 'orgFormInput border-less'}
              onChange={(event) => {
                const copyData = JSON.parse(JSON.stringify(ciData));
                for (let i = 0; i < copyData?.length; i++) {
                  if (copyData[i]?.key === record?.key) {
                    copyData[i].identification_number = event.target.value;
                  }
                }
                setCIData(copyData);
              }}
              disabled={createTenantLoading || updateTenantLoading}
            />
          )
        }
      },
      {
        title: 'Is Printable',
        render: (record) => {
          return (
            <div>
              <Checkbox
                checked={record?.is_printable}
                onChange={(event) => {
                  const copyData = JSON.parse(JSON.stringify(ciData));
                  for (let i = 0; i < copyData?.length; i++) {
                    if (copyData[i]?.key === record?.key) {
                      copyData[i].is_printable = event.target.checked;
                    }
                  }
                  setCIData(copyData);
                }}
                disabled={createTenantLoading || updateTenantLoading}
              />
            </div>
          )
        },
      },
      {
        title: '',
        width: '40px',
        render: (text, record) => (
          <Fragment>
            <div className="delete-line-button" onClick={() => handleDelete(record.key)}>
              <CloseOutlined />
            </div>
          </Fragment>
        ),
      },
    ];

    return columns;
  }

  const addNewIdentificationRow = () => {
    const copyCIData = JSON.parse(JSON.stringify(ciData));
    copyCIData.push({
      key: uuidv4(),
      identification_name: '',
      identification_number: '',
      is_printable: false,
    });
    setCIData(copyCIData);
  }

  const handleChange = ({ fileList }) => setFileList(fileList);

  function checkvalue() {
    if ((addExistingVendors || addExistingProducts)) {
      if (selectedTenantId) {
        return true;
      }
      return false;
    }

    return true;
  }

  const addTenant = () => {
    setFormSubmitted(true);
    if (selectedTenant) {
      if (tenantName && Helpers.validatePhoneNumber(phone) && Helpers.validateEmail(email) && Helpers.validateGstNumber(gstin)) {
        const payload = {
          tenant_id: selectedTenantId,
          tenant_name: tenantName,
          org_id: user?.tenant_info?.org_id,
          description: '',
          email,
          secondary_email: toRecipients,
          dial_code: countryCode,
          mobile: phone,
          is_active: true,
          gst_number: gstin,
          branch_code: branchCode,
          logo: fileList[0]?.thumbUrl,
          legal_name: legalName,
          identification_number: ciData,
        };
        const updateConfigurationPayload = {
          tenant_id: user?.tenant_info?.tenant_id,
          logo_base_64: fileList[0]?.thumbUrl,
          tenant_configuration_id: tenantsConfig?.data?.[0]?.tenant_configuration_id,
        };
        updateTenant(payload, () => {
          updateTenantConfiguration(updateConfigurationPayload,
            () => getTenantsConfiguration(user?.tenant_info?.tenant_id));
          callback();
        });
      }
    } else if (tenantName && Helpers.validatePhoneNumber(phone) && Helpers.validateEmail(email) && legalName && Helpers.validateGstNumber(gstin) && address && district && state && pinCode && checkvalue()) {
      const payload = {
        tenant_name: tenantName,
        clone_tenant_id: selectedTenantId,
        org_id: user?.tenant_info?.org_id,
        description: '',
        email,
        secondary_email: toRecipients,
        dial_code: countryCode,
        mobile: phone,
        is_active: true,
        legal_name: legalName,
        gst_number: gstin,
        logo: fileList?.[0]?.thumbUrl,
        add_existing_products: !!addExistingProducts,
        add_existing_vendors: !!addExistingVendors,
        identification_number: ciData,
        default_billing_address: {
          address1: address,
          city: district,
          state,
          country: 'India',
          postal_code: pinCode,
        },
      };

      createTenant(payload, () => {
        callback();
      });
    }
  };

  const data = user?.user_tenants?.map((tenant) => ({
    label: tenant?.tenant_name,
    value: tenant?.tenant_id,
  }));

  return (
    <div className="tenant-form__wrapper">
      <div className="ant-row" style={{ paddingBottom: '40px' }}>
        <div className="ant-col-md-12">
          <H3FormInput
            name="Tenant Name"
            type="text"
            containerClassName="orgInputContainer vendor__right-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => setTenantName(event.target.value)}
            value={tenantName}
            label="Tenant Name"
            maxlength="100"
            required
            disabled={createTenantLoading || updateTenantLoading}
            showError={formSubmitted && !tenantName}
          />
        </div>
        <div className="ant-col-md-12">
          <H3FormInput
            name="Legal Name"
            type="text"
            containerClassName="orgInputContainer vendor__left-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => setLegalName(event.target.value)}
            value={legalName}
            label="Legal / Trade Name"
            required
            disabled={createTenantLoading || updateTenantLoading}
            maxlength="50"
            showError={formSubmitted && !legalName}
          />
        </div>
        <div className="ant-col-md-12 ant-col-xs-24">
          <div className="orgInputContainer">
            <H3Text
              text="Phone"
              className="orgFormLabel"
            />
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <PRZSelect
                value={countryCode}
                showSearch
                filterOption={(input, option) => {
                  const { label } = option.props;
                  const { value } = option.props;
                  return (
                    label.toLowerCase().includes(input.toLowerCase())
                    || value.toLowerCase().includes(input.toLowerCase())
                  );
                }}
                onChange={(value) => setCountryCode(value)}
                className={formSubmitted && !countryCode ? "prz-select__error-border" : ""}
                style={{
                  // border: !(formSubmitted && !countryCode)
                  //   ? '1px solid rgba(68, 130, 218, 0.2)'
                  //   : '1px solid red',
                  borderRight: 'none',
                  borderRadius: '2px',
                  height: '28px',
                  width: '88px',
                  fontSize: '13px',
                }}
                disabled={createTenantLoading || updateTenantLoading}
              >
                {CountryCodes?.map((item) => (
                  <Option
                    key={item?.name}
                    value={item?.dial_code}
                    label={item?.name}
                  >
                    {`${item?.flag} +${item?.dial_code}`}
                  </Option>
                ))}
              </PRZSelect>
              <H3FormInput
                name="a valid phone number"
                type="text"
                containerClassName="vendor__right-input"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                placeholder=""
                onChange={(event) => setPhone(event.target.value)}
                value={phone}
                disabled={createTenantLoading || updateTenantLoading}
                maxlength="50"
              />
            </div>
            {(formSubmitted && !Helpers.validatePhoneNumber(phone)) && (
              <div className="input-error">
                *Please enter valid phone number
              </div>
            )}
          </div>
        </div>
        <div className="ant-col-md-12">
          <H3FormInput
            name="a valid GST number"
            type="text"
            containerClassName="orgInputContainer vendor__left-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => {
              setGstin(event.target.value);
            }}
            value={gstin}
            required
            disabled={createTenantLoading || updateTenantLoading}
            showError={formSubmitted && !Helpers.validateGstNumber(gstin)}
            label="GST Number"
          />
        </div>
        <div className="ant-col-md-12">
          <H3FormInput
            name="a valid email"
            type="text"
            containerClassName="orgInputContainer vendor__right-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => setEmail(event.target.value)}
            value={email}
            label="Email"
            maxlength="50"
            required
            disabled={createTenantLoading || updateTenantLoading}
            showError={formSubmitted && !Helpers.validateEmail(email)}
          />
        </div>
        <div className="ant-col-md-12">
          <div
            className="orgInputContainer vendor__left-input"
          >
            <label className="orgFormLabel">
              Secondary Email
            </label>
            <PRZSelect
              mode="tags"
              value={toRecipients}
              filterOption={false}
              maxTagCount="responsive"
              onChange={(value) => {
                const recipients = [];
                for (let i = 0; i < value?.length; i++) {
                  if (Helpers.validateEmail(value[i])) {
                    recipients.push(value[i]);
                  }
                }
                setToRecipients(recipients);
              }}
              disabled={createTenantLoading || updateTenantLoading}
              style={{
                borderRadius: '2px',
                width: '100%',
                fontSize: '13px',
                paddingTop: '2px',
              }}
              placeholder={""}
            />
            {/* {formSubmitted && !toRecipients?.length && (
              <div className="formError">
                *Please enter at least one recipient
              </div>
            )} */}
          </div>
        </div>
        <div className="ant-col-md-12">
          <H3FormInput
            name="a branch code"
            type="text"
            containerClassName="orgInputContainer vendor__right-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => setBranchCode(event.target.value)}
            value={branchCode}
            required
            disabled={createTenantLoading || updateTenantLoading}
            showError={formSubmitted && !branchCode}
            label="Branch Code"
          />
        </div>
        <div className="ant-col-md-12" />

        {!selectedTenant && (
          <div className="ant-col-md-8">
            <H3FormInput
              name="street address"
              type="text"
              containerClassName="orgInputContainer tenant-form__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setAddress(event.target.value)}
              value={address}
              label="Street Address"
              showError={formSubmitted && !address}
              disabled={createTenantLoading}
              required
            />
          </div>
        )}
        {!selectedTenant && (
          <div className="ant-col-md-8">
            <H3FormInput
              name="a valid pincode"
              type="number"
              containerClassName="orgInputContainer tenant-form__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => (event.target.value.length <= 6 ? setPinCode(event.target.value) : '')}
              onBlur={(event) => (event.target.value.length <= 6 ? getCityState(event.target.value) : '')}
              value={pinCode}
              label="Pin Code"
              required
              showError={formSubmitted && !pinCode}
              disabled={createTenantLoading}
            />
          </div>
        )}
        {!selectedTenant && (
          <div className="ant-col-md-8">
            <H3FormInput
              name="city"
              type="text"
              containerClassName="orgInputContainer tenant-form__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setDistrict(event.target.value)}
              value={district}
              label="City"
              showError={formSubmitted && !district}
              disabled={createTenantLoading}
              required
            />
          </div>
        )}
        {!selectedTenant && (
          <div className="ant-col-md-8">
            <H3FormInput
              name="state"
              type="text"
              containerClassName="orgInputContainer tenant-form__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setState(event.target.value)}
              value={state}
              label="State"
              disabled={createTenantLoading}
              showError={formSubmitted && !state}
              required
            />
          </div>
        )}

        <div className="ant-col-md-24">
          <Table
            columns={getColumns()}
            dataSource={ciData}
            pagination={false}
            size="small"
          />
          <div className="new-charge-row-button"
            style={{ margin: "10px 0px 20px 0px" }}
            onClick={() => addNewIdentificationRow()}
          >
            <span className="new-charge-row-button__icon">
              <PlusCircleFilled />
            </span>
            <div>Add Row</div>
          </div>
        </div>


        <div className="ant-col-md-24">
          <div className="orgInputContainer  profile__right-input">
            <label className="orgFormLabel">
              Your Logo
            </label>
            <div className="ant-col-md-12 ant-col-xs-24">
                        <div className="settings__profile-wrapper-img">

                          <H3ImageSelectorWithCrop>
                            <Upload
                              action={constants.UPLOAD_FILE}
                              listType="picture-card"
                              fileList={fileList}
                              onChange={handleChange}
                              showUploadList={{ showPreviewIcon: false }}
                            >
                              {fileList?.length >= 1 ? null
                                : uploadButton}
                            </Upload>
                          </H3ImageSelectorWithCrop>
                        </div>
                      </div>
          </div>
        </div>

        {!selectedTenant && (
          <Fragment>
            <div className="ant-col-md-12">
              <div className="orgInputContainer tenant-form-checkbox__wrapper vendor__right-input">
                <Checkbox disabled={createTenantLoading} checked={addExistingProducts} onChange={() => setAddExistingProducts(!addExistingProducts)} />
                {' '}
                <H3Text text="Add All Existing Products" className="orgFormLabel" />

              </div>
            </div>
            <div className="ant-col-md-12">
              <div className="orgInputContainer create-Tenant-checkbox__wrapper vendor__left-input">
                <Checkbox disabled={createTenantLoading} checked={addExistingVendors} onChange={() => setAddExistingVendors(!addExistingVendors)} />
                <H3Text text="Add All Existing Vendors" className="orgFormLabel" />

              </div>
            </div>
            {(addExistingProducts || addExistingVendors) && (
              <div className="ant-col-md-24">
                <div className="ant-col-md-14 mt-2">
                  <div
                    className="orgInputContainer vendor__right-input"
                    style={{ marginTop: '2px' }}
                  >
                    <label className="orgFormLabel">
                      Clone Settings From Tenant
                      <span style={{ color: 'red' }}>&nbsp;*</span>
                    </label>
                    <PRZSelect
                      value={selectedTenantId}
                      filterOption={false}
                      maxTagCount="responsive"
                      onChange={(value) => {
                        setSelectedTenantId(value);
                      }}
                      style={{
                        border: '1px solid rgba(68, 130, 218, 0.2)',
                        borderRadius: '2px',
                        width: '100%',
                        fontSize: '13px',
                        paddingTop: '2px',
                      }}
                    >
                      {data.map((option) => (
                        <Select.Option key={option.value} value={option.value}>
                          {option.label}
                        </Select.Option>
                      ))}
                    </PRZSelect>
                    {formSubmitted && !selectedTenantId && (addExistingVendors || addExistingProducts) && (
                      <div className="formError">
                        *Please select tenant to clone settings
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Fragment>
        )}
        <div className="ant-col-md-12" />
      </div>
      <div className="tenant-form__footer-wrapper" style={{ marginTop: '0.5rem' }}>
        <H3Button
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          text={selectedTenant ? 'Update Business Unit' : 'Add Business Unit'}
          onClick={() => addTenant()}
          isLoading={createTenantLoading || updateTenantLoading}
          disabled={createTenantLoading || updateTenantLoading}
          style={{
            width: '160px',
            borderRadius: '5px',
            padding: '7px 0px',
            marginLeft: '0',
          }}
        />
      </div>
    </div >
  );
};
const mapStateToProps = ({
  UserReducers, SellerReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  cityStateLoading: SellerReducers.cityStateLoading,
  pincodeCity: SellerReducers.pincodeCity,
  pincodeState: SellerReducers.pincodeState,
  setCityStateError: SellerReducers.setCityStateError,
  createTenantLoading: TenantReducers.createTenantLoading,
  updateTenantLoading: TenantReducers.updateTenantLoading,
  tenants: TenantReducers.tenants,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
});

const mapDispatchToProps = (dispatch) => ({
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  createTenant: (payload, callback) => dispatch(TenantActions.createTenant(payload, callback)),
  updateTenant: (payload, callback) => dispatch(TenantActions.updateTenant(payload, callback)),
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getTenantsConfiguration: (tenantId) => dispatch(TenantActions.getTenantsConfiguration(tenantId)),
  updateTenantConfiguration: (payload, callback) => dispatch(TenantActions.updateTenantConfiguration(payload, callback)),
});

TenantForm.propTypes = {
  user: PropTypes.any,
  createTenantLoading: PropTypes.bool,
  createTenant: PropTypes.func,
  pincodeCity: PropTypes.any,
  pincodeState: PropTypes.any,
  setCityState: PropTypes.func,
  getCityState: PropTypes.func,
  updateTenantLoading: PropTypes.bool,
  selectedTenant: PropTypes.any,
  callback: PropTypes.func,
  updateTenant: PropTypes.func,
  tenantsConfiguration: PropTypes.any,
  getTenantsConfiguration: PropTypes.func,
  updateTenantConfiguration: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TenantForm));
